import { BackgroundCheckColumns } from '@/backend/features/background-check/shared';
import { BackgroundCheckTypeSelect } from '@/ui/features/background-check/components/background-check-modal/components/BackgroundCheckTypeSelectModal';
import { AccountData } from '@juvare/contact-management/backend/features/accounts/shared';
import { Row } from '@juvare/platform-shared/features/storage';
import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface BackgroundCheckTypeSelectModal {
    account: AccountData;
    backgroundCheckData: Row<BackgroundCheckColumns>[];
    accountId: string;
    onCloseModal: (closed?: () => void) => void;
    ariaTitleId: string;
    ariaContentId: string;
    handleRequestBackgroundCheck: (
        account: AccountData,
        backgroundCheckData: BackgroundCheckColumns,
        accountId: string,
        reloadAccounts?: () => void,
        onCloseModal?: () => void,
    ) => void;
    onReloadAccounts?: () => void;
}

export const BackgroundCheckTypeSelectModal: React.FC<BackgroundCheckTypeSelectModal> = ({
    account,
    backgroundCheckData,
    accountId,
    onCloseModal,
    ariaTitleId,
    ariaContentId,
    handleRequestBackgroundCheck,
    onReloadAccounts,
}) => {
    const { t } = useTranslation();

    const [selectedBackgroundCheckType, setSelectedBackgroundCheckType] = React.useState(backgroundCheckData[0]?.columns.type);

    const selectedBackgroundCheckData = backgroundCheckData.find(
        (backgroundCheck) => backgroundCheck.columns.type === selectedBackgroundCheckType,
    );

    return (
        <>
            <DialogTitle id={ariaTitleId}>{t('backgroundCheck.labels.chooseABackgroundCheckType')}</DialogTitle>
            <DialogContent id={ariaContentId}>
                <BackgroundCheckTypeSelect
                    backgroundCheckType={selectedBackgroundCheckType}
                    setSelectedBackgroundCheckType={setSelectedBackgroundCheckType}
                />
            </DialogContent>
            <DialogActions>
                <Button color='primary' onClick={() => onCloseModal()}>
                    {t('common.cancel')}
                </Button>

                <Button
                    color='primary'
                    disabled={!selectedBackgroundCheckData}
                    onClick={() =>
                        handleRequestBackgroundCheck(
                            account,
                            selectedBackgroundCheckData!.columns,
                            accountId,
                            onReloadAccounts,
                            onCloseModal,
                        )
                    }
                >
                    {t('common.submit')}
                </Button>
            </DialogActions>
        </>
    );
};
